<template>
    <div class="talk-bubble" ref="bubble">
        <div class="pointer"></div>
        <div class="content">
            <slot></slot>
        </div>
    </div>
</template>

<script>
export default {
    name: "TalkBubble",
    props: ['top'],
    methods: {
        setPosition() {
            let root = document.documentElement

            root.style.setProperty('--bubble-top', this.top + 'px')
        }
    },
    watch: {
        top() {
            this.setPosition()
        }
    },
    mounted() {
        this.setPosition()
    }
}
</script>